exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._18F4aWT2kJnBtiMJCqQ1nw{\n    /* background: #2d9f86cc; */\n    width: 100%;\n    /* Remove these to build the actual component */\n    -ms-flex-line-pack: center;\n        align-content: center;\n    text-align: center;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-align: center;\n        align-items: center;\n    margin: auto;\n    display: -ms-flexbox;\n    display: flex;\n    overflow: overlay;\n}\n\n._1DAuwedeOAvtt55fjC2rC7 {\n}\n._3u6WCINFV4g2ReC_Up2cs2 {\n  width: 600px;\n  -webkit-transform-origin: 0 0;\n      -ms-transform-origin: 0 0;\n          transform-origin: 0 0;\n  background-color: #fff;\n}\n\n._3AfW_3JU7JEZO9keZvKrWk{\n    /* background: #2d9f86cc; */\n}\n\n.ZuGQ7qBATKGqQ7BUfJgHR{\n    font-size: 15px;\n    font-weight:600;\n    color: #000;\n    fill: #000;\n    font-family: 'Soleil', 'Helvetica Neue', helvetica, arial, sans-serif;\n}", ""]);

// exports
exports.locals = {
	"FullWidthECGPreviewContainer": "_18F4aWT2kJnBtiMJCqQ1nw",
	"eKGPreview": "_1DAuwedeOAvtt55fjC2rC7",
	"previewGridNoTranslate": "_3u6WCINFV4g2ReC_Up2cs2",
	"loader": "_3AfW_3JU7JEZO9keZvKrWk",
	"LeadTitle": "ZuGQ7qBATKGqQ7BUfJgHR"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/views/pages/Annotation/components/FullWidthECGPreview/FullWidthECGPreview.css
// module id = 9660
// module chunks = 23